import React from "react";
import { ButtonVariant } from "./types";
import Primary from "./Primary/Primary";
import Secondary from "./Secondary/Secondary";
import Tertiary from "./Tertiary/Tertiary";
import Fourth from "./Fourth/Fourth";

export default function ButtonWithVariant(buttonWithVariantProps) {
  const {
    variant,
    onClick,
    isLoading,
    type,
    disabled,
    label,
    icon,
    iconRight,
    iconColor,
    fontWeight,
    leftContent
  } = buttonWithVariantProps;

  const getTypeButton = (variant) => {
    switch (variant) {
      case ButtonVariant.PRIMARY:
        return (
          <Primary
            onClick={onClick}
            isLoading={isLoading}
            disabled={disabled}
            label={label}
            type={type}
            icon={icon}
            iconRight={iconRight}
          />
        );
      case ButtonVariant.SECONDARY:
        return (
          <Secondary
            type={type}
            onClick={onClick}
            isLoading={isLoading}
            disabled={disabled}
            label={label}
            icon={icon}
            leftContent={leftContent}
          />
        );
      case ButtonVariant.TERTIARY:
        return (
          <Tertiary
            type={type}
            iconColor={iconColor}
            onClick={onClick}
            isLoading={isLoading}
            disabled={disabled}
            label={label}
            icon={icon}
          />
        );
      case ButtonVariant.FOURTH:
        return (
          <Fourth
            type={type}
            iconColor={iconColor}
            onClick={onClick}
            isLoading={isLoading}
            disabled={disabled}
            label={label}
            icon={icon}
          />
        );

      default:
        return (
          <Primary
            type={type}
            onClick={onClick}
            isLoading={isLoading}
            disabled={disabled}
            label={label}
            icon={icon}
            fontWeight={fontWeight}
          />
        );
    }
  };

  return getTypeButton(variant);
}
